

















import {
  Component, Emit, PropSync, Ref, Vue, Watch,
} from 'vue-property-decorator';
import { debounce } from 'lodash';
import parseScannerInput from '@/utils/scanner';
import clickaway from '@/directives/clickaway';
import { SCANNER_DELIMITER } from '@/constants/scanner';
import TransactionDto from '@/interfaces/transaction.dto';

@Component({
  directives: {
    clickaway,
  },
})
export default class ScanField extends Vue {
  @PropSync('isScanMode', {
    type: Boolean,
  })
  isScanModeSync!: boolean;

  scanner = '';

  keydownEvents: KeyboardEvent[] = [];

  @Ref('scanArea') readonly scanArea!: HTMLTextAreaElement;

  @Watch('isScanMode', { immediate: true })
  onScanModeChange(newValue: boolean) {
    if (newValue) {
      this.focusScanArea();
    }
  }

  async focusScanArea() {
    await this.$nextTick();
    this.scanArea.focus();
  }

  onScanInput(event: KeyboardEvent) {
    this.scanner += event.key;

    this.onScannerFinishDebounced();
  }

  onScannerFinish() {
    this.processScannerInput();

    this.resetScanner();
  }

  onScannerFinishDebounced = debounce(this.onScannerFinish, 1000);

  resetScanner() {
    this.scanner = '';
    this.keydownEvents = [];
  }

  @Emit('transaction:scan')
  processScannerInput() {
    let transaction: TransactionDto | null = null;
    try {
      transaction = parseScannerInput(this.scanner);
    } catch (e) {
      if (e instanceof Error) {
        console.error(e.message);
      }
    }

    return transaction;
  }

  onScanClickAway() {
    if (this.isScanModeSync) {
      this.isScanModeSync = false;
    }
  }

  keydownInterceptor(e: KeyboardEvent) {
    this.keydownEvents.push(e);

    const { length } = this.keydownEvents;
    if (length >= 5) {
      const key0 = this.keydownEvents[length - 5].key;
      const key1 = this.keydownEvents[length - 4].key;
      const key2 = this.keydownEvents[length - 3].key;
      const key3 = this.keydownEvents[length - 2].key;
      const key4 = this.keydownEvents[length - 1].key;

      if (key0 === 'Alt' && key1 === '0' && key2 === '0' && key3 === '1' && key4 === '0') {
        this.scanner += SCANNER_DELIMITER;
      }
    }
  }
}
